"use client"

import { useState } from "react"
import { Info } from "lucide-react"
import { Popover, PopoverContent, PopoverTrigger } from "@/shared/components/ui/popover"
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/shared/components/ui/tooltip"
import { cn } from "@/shared/lib/utils"

const UNKNOWN_LOCATION_INFO_HEADING = "Location Currently Unknown option"
const UNKNOWN_LOCATION_INFO_TEXT =
  "Choose 'Location Currently Unknown' when the home's street address and map pin are not yet known. Admin/Base Leader can add a precise address and pin later. Homes with this status do not appear on the map."

type UnknownLocationInfoIconProps = {
  className?: string
}

export default function UnknownLocationInfoIcon({ className }: UnknownLocationInfoIconProps) {
  const [open, setOpen] = useState(false)

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <TooltipProvider delayDuration={300}>
        <Tooltip>
          <TooltipTrigger asChild>
            <PopoverTrigger asChild>
              <button
                type="button"
                className={cn("inline-flex h-5 w-5 items-center justify-center text-muted-foreground hover:text-foreground", className)}
                aria-label="Unknown location information"
              >
                <Info className="h-4 w-4" />
              </button>
            </PopoverTrigger>
          </TooltipTrigger>
          <TooltipContent side="bottom" className="max-w-[320px] text-xs">
            <p className="font-medium mb-1">{UNKNOWN_LOCATION_INFO_HEADING}</p>
            <p>{UNKNOWN_LOCATION_INFO_TEXT}</p>
          </TooltipContent>
        </Tooltip>
      </TooltipProvider>
      <PopoverContent side="bottom" className="max-w-[340px] text-sm">
        <p className="font-medium mb-1">{UNKNOWN_LOCATION_INFO_HEADING}</p>
        <p>{UNKNOWN_LOCATION_INFO_TEXT}</p>
      </PopoverContent>
    </Popover>
  )
}
